import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Twofivetempotravelleronrent() {



  const cardData = {
"keyword": "25 Seater Tempo Traveller on Rent in Pune",

"headingDescription":
  "Aaradhya Travels offers comfortable 25 Seater Tempo Traveller on Rent in Pune for large group travel including family tours, weddings, corporate outings, school trips, pilgrimage journeys, and outstation vacations. Our spacious AC Tempo Travellers with pushback seats and professional drivers ensure safe, smooth, and affordable travel across Pune and Maharashtra.",

"topPlaces": [
{
"title": "Amboli",
"description":
"Amboli is a hill station in the Sahyadri range famous for waterfalls, mist, and green valleys. It is ideal for nature and monsoon group tours from Pune."
},
{
"title": "Chiplun",
"description":
"Chiplun is a scenic Konkan town surrounded by rivers, greenery, and ghats. It is a popular long-road group travel destination from Pune."
},
{
"title": "Lavasa",
"description":
"Lavasa is a planned hill city known for lakeside promenade, colorful architecture, cafes, and leisure activities. It is a popular short group trip destination from Pune."
},
{
"title": "Karnala Bird Sanctuary",
"description":
"Karnala Bird Sanctuary is a protected forest area near Mumbai known for trekking, birdwatching, and nature trails. It is ideal for adventure group trips from Pune."
},
  {
"title": "Ellora Caves",
"description":
"Ellora Caves is a UNESCO World Heritage site near Aurangabad famous for rock-cut temples, sculptures, and ancient Indian architecture. It is a popular long-distance group travel destination from Pune for history and heritage tours."
},
{
"title": "Ajanta Caves",
"description":
"Ajanta Caves are UNESCO-listed Buddhist caves known for ancient paintings, carvings, and historical significance. It is a top cultural and heritage group tour destination from Pune."
},
{
"title": "Matheran",
"description":
"Matheran is Asia’s only automobile-free hill station known for viewpoints, toy train rides, and lush greenery. It is ideal for peaceful group trips from Pune."
},
{
"title": "Harihareshwar",
"description":
"Harihareshwar is a coastal pilgrimage and beach destination known as 'Dakshin Kashi'. It is popular for temple visits, beaches, and group tours from Pune."
},
{
"title": "Diveagar",
"description":
"Diveagar is a clean and less crowded beach destination known for coconut trees, calm waters, and peaceful group outings from Pune."
},
{
"title": "Bhandardara",
"description":
"Bhandardara is a scenic hill station known for Arthur Lake, Randha Falls, and beautiful monsoon views. It is a popular weekend group trip destination from Pune."
},

],



services: [
  {
    name: "Tempo Traveller 25 Seater Rent Per KM in Pune",
    description: "Tempo Traveller 25 seater rent per km in Pune service provides transparent and affordable transportation solutions for local travel, outstation tours, airport transfers, family functions, and corporate group journeys. Spacious seating and luggage capacity ensure smooth highway travel suitable for large passenger groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient 25 seater traveller reservations."
  },
  {
    name: "Tempo Traveller 25 Seater AC Bus on Rent Pune",
    description: "Tempo Traveller 25 seater AC bus on rent Pune service offers premium air-conditioned transportation for weddings, sightseeing tours, corporate events, family vacations, and outstation journeys. Comfortable seating and cooling systems ensure pleasant travel experiences during all seasons. Professional chauffeurs ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient AC bus reservations."
  },
  {
    name: "Tempo Traveller 26 Seater Non AC Bus on Rent in Pune",
    description: "Tempo Traveller 26 seater non AC bus on rent in Pune service provides economical transportation for educational tours, local travel, family outings, and budget-friendly group journeys. Spacious interiors and comfortable seating ensure smooth travel suitable for medium and large passenger groups. Professional drivers ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, schools, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient non AC bus reservations."
  },
  {
    name: "26 Bus on Rent for Wedding in Pune",
    description: "26 bus on rent for wedding in Pune service offers luxurious and spacious transportation for wedding guests, family members, bridal parties, and marriage function travel requirements. Comfortable seating and elegant interiors ensure smooth travel suitable for wedding ceremonies and celebrations. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the wedding schedule. Pickup services are available from homes, banquet halls, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient wedding bus reservations."
  },
  {
    name: "25 Bus on Rent Pimpri Chinchwad Pune",
    description: "25 bus on rent Pimpri Chinchwad Pune service provides dependable transportation for family tours, educational trips, office outings, airport transfers, and outstation journeys. Spacious buses ensure comfortable seating and smooth travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from residential societies, offices, hotels, and commercial areas across Pimpri Chinchwad Pune. Flexible booking options allow convenient bus reservations."
  },
  {
    name: "25 Bus on Rent in Pune for Picnics",
    description: "25 bus on rent in Pune for picnics service offers comfortable transportation for school outings, office day trips, family gatherings, and sightseeing tours. Spacious seating and luggage space ensure pleasant travel experiences suitable for group passengers and picnic travel. Professional drivers ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, schools, colleges, offices, hotels, and residential societies across Pune. Flexible booking options allow convenient picnic bus reservations."
  },
  {
    name: "Pune to Goa 25 Seater Bus Fare",
    description: "Pune to Goa 25 seater bus fare service provides affordable and reliable transportation for beach vacations, tourist travel, corporate outings, and family holidays from Pune. Spacious buses ensure comfortable overnight highway journeys suitable for large passenger groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the Goa route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Goa bus reservations."
  },
  {
    name: "26 Seater Tempo Traveller on Rent in Pune",
    description: "26 seater Tempo Traveller on rent in Pune service provides spacious transportation for large family groups, educational tours, wedding travel, corporate outings, and outstation journeys. Comfortable seating and luggage space ensure smooth highway travel suitable for long-distance group transportation. Professional chauffeurs ensure safe driving and reliable transportation services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient 26 seater traveller reservations."
  },
  {
    name: "25 Seater Bus on Rent in Hadapsar Pune",
    description: "25 seater bus on rent in Hadapsar Pune service offers reliable transportation for airport transfers, family tours, business travel, wedding events, and group outings from Hadapsar Pune. Spacious seating and comfortable interiors ensure pleasant travel experiences suitable for all passenger groups. Professional drivers ensure safe driving and punctual pickup services throughout the route. Pickup services are available from residential societies, offices, hotels, and commercial areas across Hadapsar Pune. Flexible booking options allow convenient bus reservations."
  },
  {
    name: "Pune to Shirdi 25 Seater Bus on Rent",
    description: "Pune to Shirdi 25 seater bus on rent service provides comfortable transportation for Sai Baba darshan tours, pilgrimage travel, family journeys, and spiritual group tours from Pune. Spacious buses ensure smooth highway travel suitable for devotees, tourists, and senior citizens. Professional chauffeurs ensure safe driving and dependable transportation services throughout the Shirdi route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Shirdi bus reservations."
  },
  {
    name: "Pune Airport to Shirdi 25 Seater Tempo Traveller on Rent",
    description: "Pune Airport to Shirdi 25 seater Tempo Traveller on rent service offers direct airport transportation for devotees, tourists, and family groups traveling to Shirdi from Pune Airport. Spacious seating and luggage capacity ensure comfortable long-distance travel suitable for pilgrimage journeys. Professional chauffeurs ensure timely airport pickup and safe driving services throughout the route. Pickup services are available directly from Pune Airport terminals with flexible scheduling options. Convenient booking options allow hassle-free airport traveller reservations."
  },
  {
    name: "Pune to Bhimashankar 25 Seater Tempo Traveller",
    description: "Pune to Bhimashankar 25 seater Tempo Traveller service provides dependable transportation for Jyotirlinga darshan tours, pilgrimage travel, family outings, and sightseeing journeys from Pune. Spacious vehicles ensure smooth ghat road travel suitable for devotees and tourist groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the Bhimashankar route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Bhimashankar traveller reservations."
  },
  {
    name: "Pune to 5 Jyotirlinga Darshan Tempo Traveller on Rent",
    description: "Pune to 5 Jyotirlinga Darshan Tempo Traveller on rent service offers comfortable transportation for devotees visiting sacred Jyotirlinga temples across Maharashtra and nearby regions. Spacious seating and smooth highway travel ensure pleasant pilgrimage journeys suitable for families and spiritual groups. Professional drivers ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Jyotirlinga traveller reservations."
  },
  {
    name: "25 Seater Tempo Traveller on Rent in Pimpri Chinchwad",
    description: "25 seater Tempo Traveller on rent in Pimpri Chinchwad service provides spacious transportation for airport transfers, corporate outings, family vacations, educational tours, and outstation journeys. Comfortable interiors and luggage space ensure smooth travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from residential societies, offices, hotels, and commercial areas across Pimpri Chinchwad Pune. Flexible booking options allow convenient traveller reservations."
  }
],

tableData: [
  ["Tempo Traveller 25 Seater Rent Per KM in Pune", "Tempo Traveller 25 Seater AC Bus on Rent Pune"],
  ["Tempo Traveller 26 Seater Non AC Bus on Rent in Pune", "26 Bus on Rent for Wedding in Pune"],
  ["25 Bus on Rent Pimpri Chinchwad Pune", "25 Bus on Rent in Pune for Picnics"],
  ["Pune to Goa 25 Seater Bus Fare", "26 Seater Tempo Traveller on Rent in Pune"],
  ["25 Seater Bus on Rent in Hadapsar Pune", "Pune to Shirdi 25 Seater Bus on Rent"],
  ["Pune Airport to Shirdi 25 Seater Tempo Traveller on Rent", "Pune to Bhimashankar 25 Seater Tempo Traveller"],
  ["Pune to 5 Jyotirlinga Darshan Tempo Traveller on Rent", "25 Seater Tempo Traveller on Rent in Pimpri Chinchwad"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable 25 Seater Tempo Traveller on Rent in Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable 25 seater Tempo Traveller rental service in Pune with comfortable vehicles, professional drivers, and smooth travel arrangements for family tours, corporate events, and group travel."
      },
      {
        WhyChooseheading: "Affordable 25 Seater Tempo Traveller Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable 25 seater Tempo Traveller on rent in Pune with transparent pricing, flexible booking plans, and complete travel assistance without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Tempo Traveller Booking Service",
        WhyChoosedescription: "Our 25 seater Tempo Traveller rental service in Pune operates 24 hours for airport transfers, weddings, school trips, corporate outings, outstation tours, and pilgrimage journeys."
      },
      {
        WhyChooseheading: "Comfortable & Fully AC 25 Seater Tempo Travellers",
        WhyChoosedescription: "All 25 seater Tempo Travellers provided by Aaradhya Travels are spacious, air-conditioned, clean, and regularly maintained for safe and comfortable group travel experiences."
      },
      {
        WhyChooseheading: "Flexible One Day & Multi-Day Tours",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day trips, weekend tours, multi-day outstation journeys, and flexible travel packages according to customer travel requirements."
      },
      {
        WhyChooseheading: "Perfect for Large Group & Corporate Travel",
        WhyChoosedescription: "The 25 seater Tempo Traveller is ideal for corporate teams, wedding guest transportation, educational tours, tourist groups, family vacations, and group sightseeing travel from Pune."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune Locations",
        WhyChoosedescription: "Aaradhya Travels provides doorstep pickup from Pune Airport, railway stations, hotels, homes, and major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Highway Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local and outstation group transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What is 25 seater Tempo Traveller on rent in Pune?", answer: "25 seater Tempo Traveller rental service in Pune provides comfortable group transportation for family trips, corporate travel, weddings, and outstation tours." },
    { question: "Is 25 seater Tempo Traveller booking available 24 hours?", answer: "Yes, Aaradhya Travels provides 24/7 25 seater Tempo Traveller rental service in Pune." },
    { question: "Can I book 25 seater Tempo Traveller for outstation travel?", answer: "Yes, customers can book 25 seater Tempo Travellers for outstation tours, hill station trips, pilgrimage journeys, and holiday travel." },
    { question: "Do you provide 25 seater Tempo Travellers for corporate events?", answer: "Yes, Aaradhya Travels provides 25 seater Tempo Traveller rental service for corporate meetings, office outings, conferences, and employee transportation." },
    { question: "Are all 25 seater Tempo Travellers air-conditioned?", answer: "Yes, all 25 seater Tempo Travellers are fully air-conditioned and maintained for comfortable group travel." },
    { question: "Can I book 25 seater Tempo Traveller online in Pune?", answer: "Yes, customers can easily book 25 seater Tempo Traveller rental service online or through phone booking." },
    { question: "Do you provide Tempo Travellers for weddings and family tours?", answer: "Yes, Aaradhya Travels provides spacious 25 seater Tempo Travellers suitable for weddings, family vacations, and group tours." },
    { question: "Are 25 seater Tempo Traveller rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for 25 seater Tempo Traveller rental?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." },
    { question: "Do you provide pickup from Pune Airport and railway stations?", answer: "Yes, Aaradhya Travels provides pickup and drop services from Pune Airport, railway stations, hotels, and all major Pune locations." }
  ];

  const testimonials = [
  {
    id: 1,
    name: "Mr. Sameer Kulkarni",
    feedback:
      "We arranged a 25 Seater Tempo Traveller on rent in Pune for our company excursion. The vehicle offered plenty of space for the entire team, and the journey was comfortable from beginning to end.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Deepali Patwardhan",
    feedback:
      "A 25 Seater Tempo Traveller rental in Pune worked perfectly for our family reunion trip. Everyone could travel together comfortably, and the vehicle was clean, spacious, and well-equipped.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "25 Seater Tempo Traveller on Rent in Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/25-seater-tempo-traveller-on-rent-pune.jpg",
  "description": "Book 25 Seater Tempo Traveller on rent in Pune with Aaradhya Travels for weddings, corporate tours, picnics, airport transfers, and outstation travel. Affordable AC and Non-AC 25/26 seater bus rental available for Goa, Mumbai, Shirdi, and Maharashtra trips.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2984"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/25-seater-tempo-traveller-on-rent-in-pune"
  }
};





  return (
    <div>
<Helmet>
  <title>
    25 Seater Tempo Traveller on Rent in Pune | AC & Non-AC Bus Hire | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire 25 Seater Tempo Traveller on rent in Pune with Aaradhya Travels. Affordable AC and Non-AC 25/26 seater bus available for weddings, picnics, corporate tours, airport transfers, Goa trips, Mumbai travel, and outstation journeys."
  />

  <meta
    name="keywords"
    content="Tempo Traveller 25 seater rent per km in Pune, Tempo Traveller 25 seater Ac bus on rent Pune, Tempo Traveller 26 seater Non Ac bus on rent in Pune, 26 bus on rent for wedding in Pune, 25 bus on rent Pimpri Chinchwad Pune, 25 Bus on rent in Pune for Picnics, Pune to Goa 25 Seater Bus fare, 26 seater tempo traveller on rent"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/10.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Twofivetempotravelleronrent;